import './App.css';
import './css/Report.css';
import './css/Navbar.css'
import "./config/instrument";
import React from 'react';
import {Routes, Route} from "react-router-dom"
import Layout from './components/Layout/Layout';
import Error404 from './components/Error/Eror404';
import Home from './components/Home';
import CreateReport from './components/Report/CreateReport';
import ListReport from './components/Report/ListReport';
import EditReport from './components/Report/EditReport';
import ReportHome from './components/Report/ReportHome';
import WHSHome from './components/WHS/WHSHome';
import WHSListReport from './components/WHS/WHSListReport';
import WHSCreateReport from './components/WHS/WHSCreateReport';
import WHSEditReport from './components/WHS/WHSEditReport';
import * as Sentry from "@sentry/react";

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    <>
      <Routes>
        <Route path="/" element={<Layout/>}>
          <Route path="rl">
            <Route path=":reportId"/>
          </Route>
          <Route path=":id">
            <Route path="" element={<Home/>}/>
            <Route path="haccp">
              <Route path="" element={<ReportHome/>}/>
              <Route path='view' element={<ListReport/>}/>
              <Route path='create' element={<CreateReport/>}/>
              <Route path="report/:date" element={<EditReport/>}/>
            </Route>
            <Route path="whs">
              <Route path="" element={<WHSHome/>}/>
              <Route path='view' element={<WHSListReport/>}/>
              <Route path='create' element={<WHSCreateReport/>}/>
              <Route path="report/:whsId" element={<WHSEditReport/>}/>
            </Route>
          <Route path="*" element={<Error404/>}/>
        </Route>
        </Route>
      </Routes>
    </>
    </Sentry.ErrorBoundary>
  );
}

export default App;
